import { ChatRole } from 'modules/chat/domain/enums/chat-role';
import { ChatMessage } from '../interfaces/chat-message';
import { ChatHistoryDto, ChatHistoryMessageDto } from '../interfaces/response-dto';

export class ChatHistoryDataMapper {
  public decode(dto: ChatHistoryDto): ChatMessage[] {
    return dto.items.map((item) => this.decodeItem(item));
  }

  private decodeItem(dto: ChatHistoryMessageDto): ChatMessage {
    const parsed = Date.parse(dto.createdAt);

    return {
      id: String(dto.id),
      role: dto.role === ChatRole.ASSISTANT ? ChatRole.ASSISTANT : ChatRole.USER,
      content: dto.content,
      createdAt: Number.isNaN(parsed) ? Date.now() : parsed,
    };
  }
}
